import * as React from 'react';
import { Component } from 'react';
import { Button, Container, Row, Col, Accordion, Card } from 'react-bootstrap';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useContext } from 'react';
import About from '../references/About.js';
import History from '../references/History.js';
import State from '../references/State.js';
import Ending from '../references/Ending.js';
import CareContinuum from '../references/CareContinuum.js';
import Testing from '../references/Testing.js';

// Article page references
import Tony from '../references/Tony.js';
import Zakia from '../references/Zakia.js';
import Jose from '../references/Jose.js';
import Dazon from '../references/Dazon.js';
import Kayla from '../references/Kayla.js';

import MarleneMcneese from '../references/MarleneMcneese.js';
import TiffanyWest from '../references/TiffanyWest.js';
import IasConference from '../references/24th-ias-conference-2022.js';
import EheMasterclass from '../references/ehe-masterclass.js';
import USCHAConference from '../references/uscha-conference.js';
import CallenLorde from '../references/CallenLorde.js';

// Champions of Change

import Champion_Dafina from '../references/championsofchange/Dafina.js';
import Champion_Danielle from '../references/championsofchange/Danielle.js';
import Champion_Dazon from '../references/championsofchange/Dazon.js';
import Champion_June from '../references/championsofchange/June.js';
import Champion_Kayla from '../references/championsofchange/Kayla.js';
import Champion_Leisha from '../references/championsofchange/Leisha.js';
import Champion_Linda from '../references/championsofchange/Linda.js';
import Champion_Marlene from '../references/championsofchange/Marlene.js';
import Champion_Raniyah from '../references/championsofchange/Raniyah.js';
import Champion_Tori from '../references/championsofchange/Tori.js';

class References extends Component {
    render() {
        const ContextAwareToggle = ({ children, eventKey, callback }) => {
            const currentEventKey = useContext(AccordionContext);
            const decoratedOnClick = useAccordionToggle(
                eventKey,
                () => callback && callback(eventKey)
            );
            const isCurrentEventKey = currentEventKey === eventKey;
            return (
                <button
                    type='button'
                    className={`${isCurrentEventKey ? 'active' : ''}`}
                    onClick={decoratedOnClick}
                    /* data-analytics-event-category="Accordions/Expanders"
          data-analytics-event-label={`HIV Testing: References ${
            isCurrentEventKey ? "Open" : "Closed"
          }`} */
                >
                    {children}
                </button>
            );
        };
        const Content = () => {
            switch (this.props.page) {
                case 'about':
                    return <About />;
                case 'history':
                    return <History />;
                case 'state':
                    return <State />;
                case 'ending-hiv':
                    return <Ending />;
                case 'care-continuum':
                    return <CareContinuum />;
                case 'testing':
                    return <Testing />;
                case 'tony':
                    return <Tony />;
                case 'zakia':
                    return <Zakia />;
                case 'jose':
                    return <Jose />;
                case 'dazon':
                    return <Dazon />;
                case 'kayla':
                    return <Kayla />;

                case 'champion-dafina':
                    return <Champion_Dafina />;
                case 'champion-danielle':
                    return <Champion_Danielle />;
                case 'champion-dazon':
                    return <Champion_Dazon />;
                case 'champion-june':
                    return <Champion_June />;
                case 'champion-kayla':
                    return <Champion_Kayla />;
                case 'champion-leisha':
                    return <Champion_Leisha />;
                case 'champion-linda':
                    return <Champion_Linda />;
                case 'champion-marlene':
                    return <Champion_Marlene />;
                case 'champion-raniyah':
                    return <Champion_Raniyah />;
                case 'champion-tori':
                    return <Champion_Tori />;


                case 'marlene-mcneese':
                    return <MarleneMcneese />;
                case 'tiffany-west':
                    return <TiffanyWest />;
                case '24th-ias-conference-2022':
                    return <IasConference />;
                case 'ehe-masterclass':
                    return <EheMasterclass />;
                case 'USCHA-conference-2022':
                    return <USCHAConference />;
                case 'callen-lorde':
                    return <CallenLorde />;
            }
        };
        return (
            <div className='cont-references section my-0'>
                <Accordion>
                    <Card>
                        <Card.Header className='px-0'>
                            <Container>
                                <Row>
                                    <Col xs={11} lg={10} className='m-auto'>
                                        <ContextAwareToggle as={Button} variant='link' eventKey='0'>
                                            <span className='title'>References</span>
                                        </ContextAwareToggle>
                                    </Col>
                                </Row>
                            </Container>
                        </Card.Header>
                        <Accordion.Collapse eventKey='0'>
                            <Card.Body>
                                <Container>
                                    <Row>
                                        <Col xs={12} lg={10} className='m-auto'>
                                            <Content page={this.props.page} />
                                        </Col>
                                    </Row>
                                </Container>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        );
    }
}

export default References;
